import { Injectable } from "@angular/core";
import { OidcSecurityService } from 'angular-auth-oidc-client';
import { Observable } from 'rxjs';
import { Claims } from '../../shared/models/claims.model';
import { AccountRoles } from '../../shared/constants/account-roles.enum';
import { map, filter, take } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import * as jwt_decode from 'jwt-decode';

@Injectable()
export class AuthenticationService {

    isAuthorized: boolean;

    constructor(private oidcSecurityService: OidcSecurityService) {

    }

    public login() {
        this.oidcSecurityService.authorize(url => window.location.href = url + '&prompt=login');
    }

    public register() {
        window.location.href = environment.aadConfig.stsServer + 'authorize?p=' 
        + environment.aadConfig.sign_up_policy + '&client_id=' + environment.aadConfig.client_id 
        + '&nonce=defaultNonce&redirect_uri=' + environment.aadConfig.redirect_url + '&scope=openid&response_type=id_token&prompt=login';
    }

    public logout() {
        localStorage.clear();
        window.location.href = `${environment.aadConfig.post_logout_redirect_uri}`;
        //this.oidcSecurityService.logoff();
    }

    public getIsAuthorized(): Observable<boolean> {
        return this.oidcSecurityService.getIsAuthorized();
    }

    public getToken(): string {
        return this.oidcSecurityService.getToken();
    }
    
    // TODO: merge getUserInfo() and getUserClaims() into 1
    // public getUserInfo() {
    //    return this.oidcSecurityService.getUserData();
    //}

    public getUserClaims(): Observable<Claims> {
        return this.oidcSecurityService.getUserData().pipe(filter(user => user !== ''), take(1))
            .pipe(map(user => {
                let newUser = false;
                if (user.newUser || !user.extension_Role) {
                    newUser = user.newUser;

                    user.extension_Role = this.getRoleFromRoleClaim(user.extension_Role);
                }

                // Currently, Carrier is using property <name> but Shipper now update to given_name and family_name
                // Remove condition user.extension_Role != AccountRoles.Shipper 
                // when page Create Carrier change DisplayName to FirstName LastName
                const name = user.given_name && user.given_name !== 'unknown' && user.family_name
                    ? user.given_name.trim() + " " + user.family_name.trim()
                    : user.name;

                return new Claims(
                    user.oid,
                    user.extension_Role,
                    user.emails[0],
                    name, newUser,
                    user.extension_Type,
                    user.extension_CompanyName,
                    user.extension_PhoneNumber,
                    user.extension_CountryCode,
                    user.auth_time
                );
            })
            );
    }

    public isTokenNotExpired(): boolean {
        const token = this.getToken();

        if (token) {
            const decodedToken = jwt_decode(token);
            const tokenExpTime = new Date(decodedToken.exp * 1000);
            const now = new Date();
            return (decodedToken && (now < tokenExpTime));
        }

        return true;
    }
    
    private getRoleFromRoleClaim(roleClaim: string): string {
        // If claims is null or empty, treat it as Shipper.
        return roleClaim ? roleClaim : AccountRoles.Shipper;
    }
}